import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AdvancedSeachFilteredJobsResult } from 'src/app/job/models/dashboard/advanced-search-filtered-jobs-result.model';
import { PropertyFilteredJobsResult } from 'src/app/job/models/dashboard/property-filtered-jobs-result.model';
import { TradeFilteredJobsResult } from 'src/app/job/models/dashboard/trade-filtered-jobs-result.model';
import { Events } from 'src/app/shared/constants/events.constant';
import { SearchJobsByJobNumberResult } from 'src/app/shared/models/search-jobs-by-job-number-result.model';

import { BaseService } from '../base/base.service';
import { EventService } from '../event.service';
import { tap, distinct, mergeMap, from, toArray } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class JobSearchService extends BaseService {
  private maintenanceBaseUrl = '/maintenance/api/';
  private controller = 'job-search';

  constructor(
    http: HttpClient,
    private eventService: EventService
    
  ) {
    super(http);
  }

  searchJobsByJobNumber(fragmentOfJobNumber: string) {
    return this.get<SearchJobsByJobNumberResult[]>(
      this.maintenanceBaseUrl +
        this.controller +
        '/by-jobnumber?FragmentOfJobNumber=' +
        fragmentOfJobNumber
    );
  }

  searchOpenJobsByProperty(queryDto) {
    return this.post<PropertyFilteredJobsResult[]>(
      `${this.maintenanceBaseUrl + this.controller}/open-jobs-by-property`,
      queryDto
    );
  }

  searchClosedJobsByProperty(queryDto) {
    return this.post<PropertyFilteredJobsResult[]>(
      `${this.maintenanceBaseUrl + this.controller}/closed-jobs-by-property`,
      queryDto
    );
  }

  searchRecurringJobsByProperty(queryDto) {
    return this.post<PropertyFilteredJobsResult[]>(
      `${this.maintenanceBaseUrl + this.controller}/recurring-jobs-by-property`,
      queryDto
    );
  }

  searchOpenJobsByTrade(queryDto) {
    return this.post<TradeFilteredJobsResult[]>(
      `${this.maintenanceBaseUrl + this.controller}/open-jobs-by-trade`,
      queryDto
    );
  }

  searchClosedJobsByTrade(queryDto) {
    return this.post<TradeFilteredJobsResult[]>(
      `${this.maintenanceBaseUrl + this.controller}/closed-jobs-by-trade`,
      queryDto
    );
  }

  searchRecurringJobsByTrade(queryDto) {
    return this.post<TradeFilteredJobsResult[]>(
      `${this.maintenanceBaseUrl + this.controller}/recurring-jobs-by-trade`,
      queryDto
    );
  }
  getSelectedTeam() {
    return this.get<any>(
      this.maintenanceBaseUrl + this.controller + '/selected-team'
    );
  }

  public updateSelectedTeam(selectedTeam: string[]) {
    let data = { selectedTeam: selectedTeam };
    return this.patch(
      `${this.maintenanceBaseUrl + this.controller}/selected-team`,
      data
    ).pipe(
      tap(() => {
        setTimeout(() => this.eventService.dispatch(Events.TeamSelectionChangedEvent), 2000);
      })
    );
  }
  
  getAdvancedSearchData(queryDto) {
    return this.post<AdvancedSeachFilteredJobsResult[]>(
      `${this.maintenanceBaseUrl + this.controller}/advanced-search-jobs`,
      queryDto
    ).pipe(
      mergeMap((item) => from(item)),
      distinct((item) => item.id),
      toArray()
    );
  }

}
